// This was modified from the tiptap highlight extention: https://github.com/ueberdosis/tiptap/tree/main/packages/extension-highlight
import { Mark, mergeAttributes } from "@tiptap/core";
export const Highlight = Mark.create({
    name: "highlight",
    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },
    addAttributes() {
        return {
            color: {
                default: null,
                parseHTML: (element) => element.getAttribute("data-color") || element.style.backgroundColor,
                renderHTML: (attributes) => {
                    if (!attributes.color) {
                        return {};
                    }
                    return {
                        "data-color": attributes.color,
                        style: `background-color: ${attributes.color}; color: inherit`,
                        class: "highlighted",
                    };
                },
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: "mark",
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return [
            "mark",
            mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
            0,
        ];
    },
    addCommands() {
        return {
            setHighlight: () => ({ commands }) => {
                return commands.setMark(this.name, { color: "#D9D9D9" });
            },
            unsetAllHighlights: () => ({ editor, chain }) => {
                const prevFrom = editor.view.state.selection.$from.pos;
                const prevTo = editor.view.state.selection.$to.pos;
                return chain()
                    .selectAll()
                    .unsetMark(this.name)
                    .setTextSelection({ from: prevFrom, to: prevTo })
                    .setMeta("addToHistory", false)
                    .run();
            },
        };
    },
});
//# sourceMappingURL=Highlight.js.map